<template>
  <div id="document-place">
    <span>{{ getEntityName }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { ActionEntityId, ContactEntityId, ExpedientEntityId, InvoiceEntityId } from '@/general/entityIds'

@Component
class EntityNameColumnTemplateComponent extends Vue {
  data: any = null

  get getEntityName() {
    if (!this.data?.idEntityType) return null

    const entityType = this.data.idEntityType

    // Expediente
    if (entityType === ExpedientEntityId.EXPEDIENTS) {
      return this.data.idOwnFile || null
    }

    // Contacto
    if (Object.values(ContactEntityId).includes(entityType)) {
      return this.data.contact || null
    }

    // Acciones
    if (Object.values(ActionEntityId).includes(entityType)) {
      return this.data.actionName || null
    }

    // Facturas
    if (Object.values(InvoiceEntityId).includes(entityType)) {
      return this.data.idOwnFile || null
    }

    return null
  }
}

export default EntityNameColumnTemplateComponent
</script>
